export default __webpack_public_path__ + "static/media/background-7.ea484b29.jpg";